import { ApolloClient, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";

const uploadLink = createUploadLink({
  uri: "/graphql",
});

const authLink = setContext((_, { headers }) => {
  // Get CSRF token from meta tag or document
  const csrfToken =
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ||
    document
      .querySelector('input[name="authenticity_token"]')
      ?.getAttribute("value");

  return {
    headers: {
      ...headers,
      "X-CSRF-Token": csrfToken,
      // Remove Content-Type header to let apollo-upload-client handle it
      // It will set multipart/form-data for uploads or application/json for regular queries
    },
  };
});

export const graphqlClient = new ApolloClient({
  link: authLink.concat(uploadLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});
